import { render, staticRenderFns } from "./UserInvitationConfirm.vue?vue&type=template&id=4623bb96&scoped=true"
import script from "./UserInvitationConfirm.vue?vue&type=script&lang=js"
export * from "./UserInvitationConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4623bb96",
  null
  
)

export default component.exports